import React, { Fragment, useEffect } from "react";
import { API_URL } from "@data/GlobalData.js";
import {
  CFW_HYDRATION_COMPLETE,
  Response_TranslationData,
} from "@genericComponents/CFW.js";
import { PostData } from "@genericComponents/SFW.js";
import {
  GetState,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
const useProductLanguageCode =
  await import("@customHooks/useProductLanguageCode.js").then(
    (mod) => mod.useProductLanguageCode,
  );
const CommonDebouncer = await import("@asyncImports/CommonDebouncer.js").then(
  (mod) => mod.CommonDebouncer,
);
const FreshTranslations = () => {
  const { languageCode } = useProductLanguageCode();
  const responseState = `${Response_TranslationData}-${languageCode}`;
  const GetFreshTranslations = () => {
    if (!GetState(responseState)) {
      PostData(
        `${API_URL}GetTranslations/${languageCode}`,
        null,
        null,
        (data) => {
          const translations = {};
          Object.keys(data).forEach((langItem) => {
            translations[langItem.replace(/\D/g, "")] =
              data[langItem].TranslationDescription;
          });
          window.initScripts[responseState] = translations;
          SetState(responseState, translations);
          return translations;
        },
      );
    }
  };
  useEffect(() => {
    document.removeEventListener("mouseenter", GetFreshTranslations, false);
    document.removeEventListener("touchenter", GetFreshTranslations, false);
    document.addEventListener("touchenter", GetFreshTranslations);
    document.addEventListener("mouseenter", GetFreshTranslations);
    const debounceTimer = () => {
      SetState(CFW_HYDRATION_COMPLETE, true);
      observer.disconnect();
    };
    const observer = new MutationObserver(() => {
      CommonDebouncer(CFW_HYDRATION_COMPLETE, debounceTimer, 2000);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    return () => {
      RemoveState(CFW_HYDRATION_COMPLETE);
      document.removeEventListener("touchenter", GetFreshTranslations, false);
      document.removeEventListener("mouseenter", GetFreshTranslations, false);
      clearTimeout(debounceTimer);
      observer.disconnect();
    };
  }, []);
  return <Fragment />;
};
export default FreshTranslations;
